module.exports = __webpack_public_path__ + "static/img/3.09cbc4c5.jpg";